import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

/**
 * ConfirmDialog — small modal for yes/no decisions.
 *
 * <ConfirmDialog
 *   isOpen={open}
 *   onClose={() => setOpen(false)}
 *   onConfirm={handleDelete}
 *   title="למחוק את הפוסט?"
 *   description="פעולה זו אינה הפיכה."
 *   confirmLabel="מחק"
 *   confirmVariant="danger"
 * />
 */
export function ConfirmDialog({
    isOpen,
    onClose,
    onConfirm,
    title = 'אישור',
    description,
    confirmLabel = 'אישור',
    cancelLabel = 'ביטול',
    confirmVariant = 'primary',
    loading = false,
}) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size="sm"
            footer={
                <>
                    <Button variant="ghost" onClick={onClose} disabled={loading}>
                        {cancelLabel}
                    </Button>
                    <Button variant={confirmVariant} onClick={onConfirm} loading={loading}>
                        {confirmLabel}
                    </Button>
                </>
            }
        >
            {description && (
                <p className="text-ink-muted leading-relaxed">{description}</p>
            )}
        </Modal>
    );
}

export default ConfirmDialog;
